import { Chip } from '@truepill/react-capsule'
import type { Icon } from 'react-feather'
import type { CSSObject } from 'styled-components'

type CircularChipProps = {
  Icon: Icon
  css?: CSSObject
}

const CircularChip = ({ Icon, css }: CircularChipProps): JSX.Element => {
  return (
    <Chip
      css={{
        height: '1.75rem',
        width: '1.75rem',
        color: 'var(--cap-colors-typography-white)',
        backgroundColor: 'var(--cap-colors-primary-700)',
        p: {
          padding: '0 0 0 0',
        },
        ...css,
      }}
    >
      <Icon style={{ height: '1.2rem', width: '1.2rem', cursor: 'pointer' }}></Icon>
    </Chip>
  )
}

export default CircularChip
